<template>
  <div
    class="entry"
    @click="click"
  >
    <div
      v-if="profile.show_project_color"
      class="projectindicator"
      :class="profile.project_color_left ? 'left' : 'top'"
      :style="projectColor"
    />
    <confirm
      v-if="confirmDelete"
      ref="confirmation"
      :text="'Wollen Sie den Eintrag wirklich löschen?'"
      @update="deleteEntry"
    />
    <div
      class="header"
    >
      <div class="project">
        {{ log.project.name }}
      </div>
      <div
        v-if="profile.show_employee_color"
        class="colorindicator"
        :style="employeeColor"
      />
    </div>
    <div
      v-if="profile.show_operation"
      class="info"
    >
      <div class="operation">
        {{ log.operation && log.operation.name }}
      </div>
    </div>
    <div
      class="description"
    >
      {{ log.description | truncate(250) }}
    </div>
    <div
      class="meta"
    >
      <div
        v-if="profile.show_employee_name"
        class="employee"
      >
        {{ getEmployeeLabel(log.employee) }}
      </div>
      <div
        v-if="profile.show_place_and_journey"
        class="journey"
      >
        {{ log.place }}, {{ log.journey }}km
      </div>
    </div>
    <div class="footer dflex flex-row">
      <div
        class="taskduration ml-auto"
      >
        {{ log.taskduration | duration }}
      </div>
    </div>
    <v-dialog
      v-model="showEditDialog"
      persistent
      scrollable
    >
      <Edit
        :log="log"
        direction="column"
        show-cancel-button
        show-delete-button
        @saved="$emit('saved', $event); showEditDialog = false"
        @delete="confirmDelete = true"
        @cancel="showEditDialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { api, endpoints } from '@/api'

import Edit from './Edit'
import Confirm from '../Confirm'

import { formatStringDuration } from '../../filters/Duration'
import { getEmployeeLabel } from '../../filters/Employee'

import truncate from '../../filters/Truncate'

export default {
  name: 'Item',
  components: {
    Edit,
    'confirm': Confirm
  },
  props: {
    log: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      showEditDialog: false,
      confirmDelete: false,
    }
  },
  computed: {
    employeeColor () {
      if (this.log) {
        return {
          'background-color': this.log.employee_color,
        }
      }
      return {}
    },
    projectColor () {
      if (this.log) {
        return {
          'background-color': this.log.project_color,
        }
      }
      return {}
    },
    ...mapGetters({
      profile: 'profile'
    })
  },
  filters: {
    truncate: truncate,
    duration: formatStringDuration
  },
  methods: {
    click () {
      this.showEditDialog = true
    },
    async deleteEntry (status) {
      this.confirmDelete = false
      if (status === true) {
        try {
          const r = await api(endpoints.fetch_log(this.log.id), undefined, {method: 'DELETE'})
          if (r.ok) {
            this.$emit('deleted', this.log)
            this.$root.$emit("logsChanged")
          } else {
            // TODO: error handling
          }
        } catch (err) {
          // TODO: error handling
        }
      }
    },
    getEmployeeLabel: getEmployeeLabel
  },
}
</script>

<style lang="scss" scoped>
.entry {
  margin: 5px 4px 2px 5px;
  padding: 5px 5px 20px 5px;
  border-radius: 0px;
  position: relative;
  background-color: white;
  border-radius: 3px;
  box-shadow: rgba(186, 186, 186, 0.5) 0px 1px 2px 0px;
  word-break: break-all;
  overflow: hidden;

  &:hover {
    cursor: pointer;
    background-color: #f5f5f5;
  }

  .info {
    display: inline-block;
    .operation {
      font-size: 13px;
      font-weight: bold;
      display: inline-block;
    }
  }
  .projectindicator {
    position: absolute;
    top: 0;
    left: 0;
    &.left {
      bottom: 0;
      width: 2px;
    }
    &.top {
      right: 0;
      height: 2px;
    }
  }
  .header {
    font-size: 13px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;

    .colorindicator {
      margin-top: 2px;
      display: block;
      height: 12px;
      width: 12px;
      border-radius: 4px;
    }

    .project {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .description {
    font-size: 13px;
    line-height: 1.3;
  }
  .meta {
    font-size: 13px;
    float: right;
    display: block;
    position: relative;
    width: 100%;
    .employee {
      position: relative;
      float: left;
      left: 0;
      width: 50%;
    }
    .journey {
      float: right;
      position: relative;
      width: 50%;
      text-align: right;
      word-break: keep-all;
    }
  }
  .footer {
    display: flex;
    height: 17px;
    right: 0;
    bottom: 0;
    left: 0;
    position: absolute;
    margin: 1px 4px 2px 4px;
    .icon {
      margin: 0 2px 0 2px;
      cursor: pointer;
    }
    .taskduration {
      margin-top: -3px;
      font-weight: bold;
      font-size: 13px;
    }
  }
  .actions {
    opacity: 0.0;
  }
  &:hover .actions {
    opacity: 1.0;
  }
}
.icon {
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
}
</style>
